import React, { useState } from "react";
import { Box, Container, CircularProgress } from "@mui/material";
import { Outlet, useNavigate } from "react-router-dom";

import Header from "../components/Header";
import SideMenu from "../components/SideMenu";
import Footer from "../components/Footer";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";

const MainLayout = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const navigate = useNavigate();
  const { getTotalItems } = useCart();

  const { user, loading, logout } = useAuth();

  const toggleDrawer = () => setDrawerOpen((prev) => !prev);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">

      {/* ✅ HEADER ALWAYS VISIBLE */}
      <Header
        toggleDrawer={toggleDrawer}
        user={user}
        getTotalItems={getTotalItems}
        onLogout={handleLogout}
      />

      {/* ✅ SIDEMENU ALWAYS ENABLED */}
      <SideMenu
        open={drawerOpen}
        toggleDrawer={toggleDrawer}
        navigate={navigate}
        user={user}
        onLogout={handleLogout}
      />

      {/* ✅ MAIN CONTENT */}
      <Container sx={{ flex: 1, py: 3 }}>
        {loading ? (
          <Box display="flex" justifyContent="center" mt={5}>
            <CircularProgress />
          </Box>
        ) : (
          <Outlet />
        )}
      </Container>

      {/* ✅ FOOTER ALWAYS */}
      <Footer />
    </Box>
  );
};

export default MainLayout;